export const msInMinute = 60 * 1000;
export const defaultSessionSampleRate = 0.1;
